import type { FeatureFlag, Workload } from "./types";

const ALL_FEATURES: FeatureFlag[] = [
  "chat",
  "storage",
  "search",
  "ai",
  "realtime",
  "files",
];

function isFeatureFlag(x: unknown): x is FeatureFlag {
  return typeof x === "string" && ALL_FEATURES.includes(x as FeatureFlag);
}

/** Відновлення workload з localStorage / JSON. */
export function coerceWorkload(x: unknown): Workload | null {
  if (!x || typeof x !== "object") return null;
  const o = x as Record<string, unknown>;

  const usersDaily = Number(o.usersDaily);
  const requestsPerUser = Number(o.requestsPerUser);
  if (!Number.isFinite(usersDaily) || usersDaily < 1) return null;
  if (!Number.isFinite(requestsPerUser) || requestsPerUser < 1) return null;

  const rawFeatures = Array.isArray(o.enabledFeatures)
    ? o.enabledFeatures.filter(isFeatureFlag)
    : [];
  const enabledFeatures: FeatureFlag[] =
    rawFeatures.length > 0 ? rawFeatures : ["chat"];

  const avgPromptTokens = Math.max(0, Math.round(Number(o.avgPromptTokens) || 0));
  const avgCompletionTokens = Math.max(
    0,
    Math.round(Number(o.avgCompletionTokens) || 0),
  );
  let aiRequestShare = Number(o.aiRequestShare);
  if (!Number.isFinite(aiRequestShare)) aiRequestShare = 0;
  aiRequestShare = Math.min(1, Math.max(0, aiRequestShare));

  let storageKbPerUser = Number(o.storageKbPerUser);
  if (!Number.isFinite(storageKbPerUser) || storageKbPerUser < 1) {
    storageKbPerUser = enabledFeatures.includes("files") ? 512 : 48;
  }

  const hasAi = enabledFeatures.includes("ai");
  const w: Workload = {
    usersDaily: Math.min(100_000_000, Math.round(usersDaily)),
    requestsPerUser: Math.min(50_000, Math.round(requestsPerUser)),
    enabledFeatures,
    avgPromptTokens: hasAi ? avgPromptTokens : 0,
    avgCompletionTokens: hasAi ? avgCompletionTokens : 0,
    aiRequestShare: hasAi ? aiRequestShare : 0,
    storageKbPerUser: Math.round(storageKbPerUser),
  };

  return w;
}

export function toggleFeature(
  list: FeatureFlag[],
  flag: FeatureFlag,
  on: boolean,
): FeatureFlag[] {
  const set = new Set(list);
  if (on) set.add(flag);
  else set.delete(flag);
  const next = [...set];
  return next.length ? next : ["chat"];
}
